export default __webpack_public_path__ + "static/media/gallery1.b4f379ce.jpg";